export const API_URL = "https://server-theta-six.vercel.app";
export const IMG_URL = "https://server-e-temp.onrender.com/uploads/";
